import axios, { AxiosResponse } from 'axios';

import { CancelReservationModel, ReservationModel } from '../../../models';

export const addReservation = async (
  reservation: ReservationModel
): Promise<AxiosResponse<any, any>> => {
  return await axios.post(
    (window.configuration?.apiGateway ?? '') + '/reservations',
    { ...reservation },
    {}
  );
};

export const getReservationByCancelCode = async (
  cancelCode: string
): Promise<CancelReservationModel> => {
  const response: AxiosResponse<any, any> = await axios.get(
    (window.configuration?.apiGateway ?? '') + '/reservations/' + cancelCode,
    {}
  );
  return response.data;
};

export const cancelReservation = async (
  cancelCode: string
): Promise<AxiosResponse<any, any>> => {
  return await axios.delete(
    (window.configuration?.apiGateway ?? '') + '/reservations/' + cancelCode,
    {}
  );
};
